module.exports = __webpack_public_path__ + "static/media/pdf-link.9512e3f4.svg";